import { VStack, HStack, Text, Pressable } from "@gluestack-ui/themed";
import { SideBarItemProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { IconNames } from "@repo/core/components/core/Icon/types";

export const SideBarItem = ({
  icon,
  label,
  isSelected,
  onPress
}: SideBarItemProps) => {
  const fontColor = isSelected ? "$primary700" : "$textLight600";

  return (
    <Pressable
      onPress={onPress}
      variant="ghost"
      bgColor={isSelected ? "$primary50" : "transparent"}
      borderRadius="$lg"
      $hover-bgColor="$primary50"
    >
      <HStack w={"$full"} alignItems="center" gap="$1" p="$2">
        <VStack alignItems="center" justifyContent="center">
          <Icon
            name={icon as IconNames}
            size="sm"
            color={fontColor}
            variant={isSelected ? "solid" : "regular"}
          />
        </VStack>
        <Text
          ml="$3"
          color={fontColor}
          textAlign="center"
          size="md"
          fontWeight={isSelected ? 600 : 400}
        >
          {label}
        </Text>
      </HStack>
    </Pressable>
  );
};
